<template>
  <Page
    :loading="isLoadingPage"
    :spinning="isSpinning"
    class="base-table"
  >
    <PageTitle>Ordbog</PageTitle>
    <p v-if="collection.length === 0">
      Der er ingen oprettede WADA klassificeringer.
    </p>

    <div class="row">
      <div
        class="col-xs-12"
        v-if="collection.length"
      >
        <div class="row bottom-xs base-table__header">
          <p class="col-xs-4 col-lg-3">
            Navn
          </p>
          <p class="col-xs-8">
            Værdi
          </p>
        </div>
        <Box
          v-for="(dictionary, dictionaryIndex) in collection"
          :key="dictionaryIndex"
        >
          <form class="row middle-xs">
            <div class="col-xs-4 col-lg-3">
              <p>{{ dictionary.group }}.{{ dictionary.key }}</p>
            </div>
            <div class="col-xs-5 col-lg-7">
              <BaseTextarea
                v-model="dictionary.value"
              />
            </div>
            <div class="col-xs-3 col-lg-2">
              <BaseButton
                label="Gem"
                full
                @click.prevent="change(dictionary)"
              />
            </div>
          </form>
        </Box>
      </div>
    </div>
  </Page>
</template>

<script>
import BaseTextarea from '../components/BaseTextarea.vue';
import Page from './Page.vue';
import BaseButton from '../components/BaseButton.vue';
import Box from '../components/Box.vue';
import PageTitle from '../components/PageTitle.vue';
import Pageload from '../mixins/Pageload';
import Request from '../mixins/Request';
import DictionaryService from '../services/DictionaryService';

export default {
    name: 'Dictionary',
    mixins: [Pageload, Request],
    components: {
        PageTitle, Box, BaseButton, Page, BaseTextarea,
    },
    data() {
        return {
            collection: [],
        };
    },
    methods: {
        async change(dictionary) {
            try {
                await DictionaryService.update(dictionary);
                this.$snotify.success(`${dictionary.group}.${dictionary.key} er opdateret`);
            } catch (error) {
                //
            }
        },
    },
    async created() {
        try {
            await this.requestData({ service: DictionaryService.getAll, storage: 'collection' });
        } catch (error) {
            //
        }
    },
};
</script>
